<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="live_classes" :label="$t(title_presential)" icon="far fa-chalkboard-teacher" />

            <q-tab-pane name="live_classes" class="q-px-md q-pb-xl q-mt-md">
                <div class="row gutter-sm" v-if="finished_loading">
                    <div class="col-xs-12 col-sm-3">
                        <filter-live-classes />
                    </div>
                    <div class="col-xs-12 col-sm-9">

                        <div class="col-12 desktop-only" v-if="banners.length > 0">
                            <q-carousel class="text-white" height="200px" infinite autoplay>
                                <q-carousel-slide :img-src="banner.image_desktop" v-for="(banner, index) in banners" :key="index" />
                            </q-carousel>
                        </div>

                        <div class="col-12 mobile-only" v-if="banners.length > 0 && showBanner">
                            <q-carousel class="text-white" :height="`${getHeight}px`" infinite autoplay>
                                <q-carousel-slide :img-src="banner.image_mobile" v-for="(banner, index) in banners" :key="index" />
                            </q-carousel>
                        </div>

                        <div class="row gutter-md q-mt-xs">
                            <div class="col-xs-12 col-sm-12" v-for="(live_class, index) in filteredLiveClasses" :key="index">
                                <card-desktop :live_class="live_class" v-if="$q.platform.is.desktop" :key="live_class.id" @subscribe_live_class="subscribeLiveClass(live_class)" />

                                <card-mobile :live_class="live_class" v-if="$q.platform.is.mobile" :key="live_class.id" @subscribe_live_class="subscribeLiveClass(live_class)" />
                            </div>

                            <div class="col-xs-12 col-sm-12" v-if="filteredLiveClasses.length == 0">
                                <q-card>
                                    <q-card-title>
                                        {{ $t('no_live_class_found') }}
                                    </q-card-title>
                                    <q-card-separator />
                                    <q-card-main v-if="this.search || this.selected_areas.length > 0">
                                        {{ $t('searched_term_returned_no_results') }}
                                    </q-card-main>
                                    <q-card-main v-else>
                                        {{ $t('there_are_no_live_classes_avaliable_at_the_moment') }}
                                    </q-card-main>
                                </q-card>
                            </div>
                        </div>
                    </div>
                </div>

                <q-inner-loading :visible="!finished_loading">
                    <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
                </q-inner-loading>
            </q-tab-pane>
        </q-tabs>

        <q-dialog prevent-close v-model="confirm_subscribe_live_class" class="dialog-webcast">
            <span slot="title">{{ $t(getLiveClassSubscribeTitle()) }}</span>

            <span slot="message">
                {{ `${$t(getLiveClassSubscribeText())} ${live_class.title}` }}
            </span>

            <span slot="body" v-if="!live_class.live_class_user_subscribed">
                <q-field>
                    <q-checkbox v-model="check_emails_live_class" :label="$t('receive_emails_about_this_live_class')" />
                </q-field>
            </span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="tertiary" :label="$t('cancel')" @click="cancelSubscribeLiveClass()" />
                <q-btn :color="getLiveClassSubscribeButtonColor()" :label="$t(getLiveClassSubscribeButton())" @click="saveSubscribeLiveClass()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import Filter from 'components/live_classes/Filter'
import CardDesktop from 'components/live_classes/CardDesktop'
import CardMobile from 'components/live_classes/CardMobile'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'admin', 'courses', 'presential', 'live_classes' ] },

    data() {
        return {
            tab: 'live_classes',
            loaded_lists: false,
            live_classes: [],
            live_class: [],
            finished_loading: false,
            confirm_subscribe_live_class: false,
            check_emails_live_class: true,
            banners: []
        }
    },

    components: {
        'filter-live-classes': Filter,
        'card-desktop': CardDesktop,
        'card-mobile': CardMobile
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            search: 'live_classes/search',
            groups: 'live_classes/groups',
            areas: 'registration_lists/country_areas',
            selected_tags: 'live_classes/tags',
            selected_areas: 'live_classes/areas',
            clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        filteredLiveClasses() {
            let filtered = []
            filtered = Object.assign(this.live_classes, [])

            if (this.search) {
                filtered = filtered.filter((liveClass) => {
                    return liveClass.title.toUpperCase().includes(this.search.toUpperCase())
                })
            }

            if (this.selected_areas.length > 0) {
                filtered = filtered.filter((liveClass) => {
                    let result = this.selected_areas.filter(x => liveClass.areas.includes(x))
                    return result.length > 0 ? true : false
                })
            }

            return filtered
        },

        showBanner() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                if(obj.show_banner_mobile) return true
                else return false
            }
            else return true
        },

        getHeight() {
            let height = (180 / 323) * this.$q.screen.width
            return parseInt(height)
        },


        title_presential(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes
				}
			}
        },
    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.all([this.fetchLists(), this.fetchBanners()])
            .then(this.$axios.spread((lists, banners) => {
                this.$store.dispatch('site_lists/SET_LISTS', [lists.data])

                banners.data.map((banner) => {
                    this.banners.push(banner)
                })

                this.$q.loading.hide()
            }))
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        fetchLists() {
            return this.$axios.get('/accounts/get_site_registration_lists/', this.getHeader)
        },

        fetchBanners() {
            return this.$axios.get('/etraining_banners/banners/get_banner_by_type/?banner_type=3', this.getHeader)
        },

        fetchLiveClasses() {
            this.$q.loading.show()

            this.live_classes = []

            this.$axios.get('/etraining_live_classes/live_classes/', this.getHeader)
            .then(response => {
                response.data.results.forEach(live => {
                    let title = live.code ? `${live.code} - ${live.title}` : live.title
                    let image_small = ''
                    let image_thumb = ''

                    let obj = live.live_class_images.find((obj) => { return obj.name === 'thumbnail' })
                    if (obj) image_thumb = obj.image

                    obj = live.live_class_images.find((obj) => { return obj.name === 'small' })
                    if (obj) image_small = obj.image

                    this.live_classes.push({
                        id: live.id,
                        areas: live.areas,
                        tags: live.tags,
                        date: live.date_class,
                        title: title,
                        description: live.description,
                        timezone: this.getHumanTimezone(live.timezone),
                        status: live.status,
                        type: live.type,
                        number_of_subscribers: live.number_of_subscribers,
                        qty_limit: live.qty_limit_participants,
                        room: live.code_room,
                        users_subscribed: live.users_subscribed,
                        image_thumb: image_thumb,
                        image_small: image_small,
                    })
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.finished_loading = true
                this.$q.loading.hide()
            })
        },

        hideModal() {
            this.live_class = []
            this.show_modal = false
        },

        subscribeLiveClass(liveClass) {
            this.live_class = liveClass
            this.confirm_subscribe_live_class = true
        },

        saveSubscribeLiveClass() {
            this.$q.loading.show()

            let data = {
                    'receive_notifications': this.check_emails_live_class,
                    'subscribe': this.live_class.users_subscribed ? false : true
                }

            this.$axios.post(`/etraining_live_classes/live_classes/${this.live_class.id}/save_subscription/`, data, this.getHeader)
            .then(response => {
                if (!this.live_class.users_subscribed) {
                    this.live_class.users_subscribed = true
                    this.live_class.number_of_subscribers++

                    this.$q.notify({
                        message: this.$t('subscribed_for_live_class_successfully'),
                        type: 'positive',
                        icon: 'fal fa-sign-in'
                    })
                }
                else {
                    this.live_class.users_subscribed = false
                    this.live_class.number_of_subscribers--

                    this.$q.notify({
                        message: this.$t('unsubscribed_for_live_class_successfully'),
                        type: 'positive',
                        icon: 'fal fa-sign-out'
                    })
                }
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
                this.confirm_subscribe_live_class = false
            })
        },

        cancelSubscribeLiveClass() {
            this.confirm_subscribe_live_class = false
            this.check_emails_live_class = true
            this.hideModal()
        },

        getLiveClassSubscribeTitle() {
            if (!this.live_class.users_subscribed) return 'subscribe'
            else return 'unsubscribe'
        },

        getLiveClassSubscribeButton() {
            if (!this.live_class.users_subscribed) return 'subscribe'
            else return 'unsubscribe'
        },

        getLiveClassSubscribeButtonColor() {
            if (!this.live_class.users_subscribed) return 'positive'
            else return 'negative'
        },

        getLiveClassSubscribeText() {
            if (!this.live_class.users_subscribed) return 'confirm_subscribing_to_the_live_class'
            else return 'confirm_unsubscribing_to_the_live_class'
        },

        getHumanTimezone(location) {
            const gmt = moment.tz(location).format('z')
            if (gmt === 'GMT') {
                return `${gmt} 0`
            } else return `GMT ${gmt}`
        }
    },

    watch: {
        search: function() {
            this.fetchLiveClasses()
        },

        tags: function() {
            this.fetchLiveClasses()
        },

        reload_content: function() {
            this.fetchLiveClasses()
        }
    },

    created() {
        this.fetchAll()
        this.fetchLiveClasses()
    }
}
</script>

<style lang="stylus" scoped>
p
    margin 0 0 10px

.training-thumb
    width 90%
    height auto
    border-radius 10px
</style>
